import { render, staticRenderFns } from "./ChartLeakSizeTb.vue?vue&type=template&id=30cc5792&scoped=true&"
import script from "./ChartLeakSizeTb.vue?vue&type=script&lang=js&"
export * from "./ChartLeakSizeTb.vue?vue&type=script&lang=js&"
import style0 from "./ChartLeakSizeTb.vue?vue&type=style&index=0&id=30cc5792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cc5792",
  null
  
)

/* custom blocks */
import block0 from "./ChartLeakSizeTb.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports